import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import PrimaryTheme from '../../Themes/Primary';
import DialogActions from '@material-ui/core/DialogActions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Reducers } from '../../Interfaces/Interfaces';
import { getUserDetails } from '../../redux/actions/userActions';
import Input from '../../components/Input';
import StatusAlert from '../../components/StatusAlert';
import { resetTransactionPIN } from '../../redux/actions/CoordinatorActions';
import Banner from '../../components/Banner';
import { resetAggregatorPin, resetUserPersonnelPin } from '../../redux/actions/AggregatorAction';

export default function ResetPassword() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [otp, setOtp] = React.useState('');
  const [pin, setNewPassword] = React.useState('');
  const [confirmPin, setConfirmPassword] = React.useState('');
  const [isPasswordValid, setPasswordValid]: any = React.useState(null);
  const [isPasswordMatch, setPasswordMatch]: any = React.useState(null);
  const [submitted, setSubmitted]: any = React.useState(false);
  const [visible, setVisibility] = React.useState(false);

  var UserType = {
    Aggregator: 5,
    Coordinator: 8,
    UserPersonnel: 9,
  };
  let userType = JSON.parse(sessionStorage.getItem("userType") || "{}");
  const handleRefresh = () => {
    dispatch({
      type: 'LOADING',
      payload: true
    });
    dispatch({
      type: "STATUS_ALERT",
      payload: false
    });

    setPasswordMatch(null);
    setPasswordValid(null);
    setSubmitted(false);
    setOtp("");
    setNewPassword("");
    setConfirmPassword("");

    dispatch(getUserDetails(user.phoneNumber));
  }

  const validatePin = (text: any) => {
    if (text.length !== 4) {
      setPasswordValid(false);
      setNewPassword(text);
    } else {
      setPasswordValid(true);
      setNewPassword(text);
    }
  };

  const matchPassword = (text: string) => {
    setConfirmPassword(text);
    if (text === pin) {
      setPasswordMatch(true);
    } else {
      setPasswordMatch(false);
    }
  }

  const handleSubmit = () => {
    var data = {
      otp,
      newPin: pin,
      confirmPin: confirmPin
    }

    setSubmitted(true);
    setVisibility(false); 
switch(userType){
  case UserType.Aggregator:
    dispatch(resetAggregatorPin(  {
      otp,
      newPin: pin,
      confirmPin: confirmPin,
      aggregatorId:user.id
    }));
    break;
    case UserType.UserPersonnel:
      dispatch(resetUserPersonnelPin(
        {
          otp,
          newPin: pin,
          confirmPin: confirmPin,
          userId:user.userId
        }
      ));
      break;
      case UserType.Coordinator:
        dispatch(resetTransactionPIN(data));
        break;
        default :
        dispatch(resetAggregatorPin(
          {
            otp,
            newPin: pin,
            confirmPin: confirmPin,
            aggregatorId:user.id
          }
        ));
    break;
}
  }

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false
    });
    history.push('/dashboard');
  }

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

        setSubmitted(false);

      } else {

        // enqueueSnackbar(alert.message, { variant: "success" });
        // handleRefresh();

        dispatch({
          type: 'ALERT',
          payload: {}
        });

        history.push('/dashboard');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div className="col-md-5 ml-auto mr-auto modal-container mt-5">

      <Banner
        className="bq-warning"
        text={"Reset Transaction PIN"}
        iconColor={PrimaryTheme.dark}
      />

      <DialogContent>

        <div className="col-md-12 p-0">
          <label htmlFor="otp" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>OTP</label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            isPassword
            id="otp"
            placeholder='Enter OTP'
            value={otp}
            visibilityIcon={visible ? "visibility_off" : "visibility"}
            onIconClick={() => setVisibility(!visible)}
            onChange={(e) => setOtp(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="new-password" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>New PIN</label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            valid={isPasswordValid}
            id="new-password"
            value={pin}
            onChange={(e) => validatePin(e.target.value)}
            placeholder='Enter New PIN'
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="confirm-password" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Confirm PIN</label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            id="confirm-password"
            placeholder='Confirm PIN'
            valid={isPasswordMatch}
            value={confirmPin}
            onChange={(e) => matchPassword(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
              padding: '1.1rem',
              borderRadius: 100
            }} />
        </div>

      </DialogContent>

      <DialogActions>
        <div className="col-md-8 ml-auto mr-auto mb-0">

          <Input
            type="button"
            isInput
            id="confirm-password"
            value={submitted ? "Changing..." : "Reset PIN"}
            disabled={submitted ||
              otp === "" ||
              pin === "" ||
              confirmPin === "" ||
              (!isPasswordValid && isPasswordValid !== null) ||
              (!isPasswordMatch && isPasswordMatch !== null)
            }
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: '1.1rem',
              borderRadius: 100
            }}
            onClick={handleSubmit}
          />
        </div>
      </DialogActions>

      <StatusAlert
        title={"PIN Changed Successfully"}
        subtitle={"Your PIN has changed successfully."}
        buttonTitle="Done"
        backTitle="Back to dashboard"
        goBack={goBack}
        onClick={handleRefresh}
      ></StatusAlert>

    </div>

  )
}
